/**
 * Whether a CSS media query matches, kept up to date (e.g. the kit's narrow-screen layouts that
 * need a different structure, not only different styles). False where matchMedia is missing.
 */
import { useCallback, useSyncExternalStore } from 'react'

export function useMediaQuery(query: string): boolean {
    const subscribe = useCallback(
        (onChange: () => void) => {
            if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
            const list = window.matchMedia(query)
            list.addEventListener('change', onChange)
            return () => list.removeEventListener('change', onChange)
        },
        [query],
    )
    return useSyncExternalStore(
        subscribe,
        () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
        () => false,
    )
}

/** Phones: the kit's `max-sm` breakpoint (below 640px, see tokens.css). */
export const PHONE = '(max-width: 639.98px)'
